<div class="SLV2-main-wrapper">
    <div class="SLV2-playback-body-section">

        <div class="SLV2-section-wrap SLV2-page-header-area">
            <button (click)="navigateToPreviousPage()" class="SLV2-header-text-button">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/banner-back-arrow.svg" />
                <span>Back</span>
            </button>
        </div>

        <div class="SLV2-playback-page-col-wrap">

            <div class="SLV2-playback-col left">
                <div class="SLV2-play-video-wrap" *ngIf="this.videoFullData?.sourceName !='Youtube'">
                    <video  #video width="100%" autoplay controls controlsList="nodownload" (ended)="videoEnded()"
                    oncontextmenu="return false;" (timeupdate)="dispatchEventsOnTimeUpdate($event)" [src]="videoFullData?.videoURL" >
                    </video>
                </div>
                <div  class="SLV2-play-video-wrap video-iframe-box" *ngIf="this.videoFullData?.sourceName =='Youtube'">
                    <div class="SLV2-yt-btn-group d-hide">
                        <button class="SLV2-yt-back-btn mobview" (click)="navigateToPreviousPage()"><img class="ml-0mr-2 bck-icn" src="selflearnv2-ui/assets/img/back-button.svg" alt=""> GO BACK</button>
                      </div>
                    <button *ngIf="!videoFullscreenStatus" class="SLV2-yt-fullscreen-btn sm" (click)="showFullScreen()"><img src="selflearnv2-ui/assets/img/self-learn-v2/fullscreen-icon-2.svg" /></button>
                    <div id="video-iframe-container" class="video-iframe-container" [ngClass]="{'fullscreenMode':videoFullscreenStatus}" (dblclick)="divdblClick($event)" (click)="divClick($event)">
                        <div class="yt-playback-speed">
                            <div class="yt-playback-speed-list-overlay" *ngIf="videoPlaybackStatus">
                                <ul class="yt-playback-speed-list"  (click)="videoPlayback()">
                                    <li><button class="yt-pb-link"   [ngClass]="{'active':currentVideoPlaybackSpeed == 0.25}" (click)="changePlaybackSpeed(0.25)">0.25</button></li>
                                    <li><button class="yt-pb-link" [ngClass]="{'active':currentVideoPlaybackSpeed == 0.5}" (click)="changePlaybackSpeed(0.5)">0.5</button></li>
                                    <li><button class="yt-pb-link"  [ngClass]="{'active':currentVideoPlaybackSpeed == 0.75}" (click)="changePlaybackSpeed(0.75)">0.75</button></li>
                                    <li><button class="yt-pb-link "   [ngClass]="{'active':currentVideoPlaybackSpeed == 1}" (click)="changePlaybackSpeed(1)">Normal</button></li>
                                    <li><button class="yt-pb-link"  [ngClass]="{'active':currentVideoPlaybackSpeed == 1.25}"  (click)="changePlaybackSpeed(1.25)">1.25</button></li>
                                    <li><button class="yt-pb-link" [ngClass]="{'active':currentVideoPlaybackSpeed == 1.5}"  (click)="changePlaybackSpeed(1.5)">1.5</button></li>
                                    <li><button class="yt-pb-link" [ngClass]="{'active':currentVideoPlaybackSpeed == 1.75}"  (click)="changePlaybackSpeed(1.75)">1.75</button></li>
                                </ul>
                            </div>
                            <button class="yt-playback-speed-btn" [ngClass]="{'active':videoPlaybackStatus}" (click)="videoPlayback()">
                                <svg height="24" viewBox="0 0 24 24" width="24"><path d="M10,8v8l6-4L10,8L10,8z M6.3,5L5.7,4.2C7.2,3,9,2.2,11,2l0.1,1C9.3,3.2,7.7,3.9,6.3,5z            M5,6.3L4.2,5.7C3,7.2,2.2,9,2,11 l1,.1C3.2,9.3,3.9,7.7,5,6.3z            M5,17.7c-1.1-1.4-1.8-3.1-2-4.8L2,13c0.2,2,1,3.8,2.2,5.4L5,17.7z            M11.1,21c-1.8-0.2-3.4-0.9-4.8-2 l-0.6,.8C7.2,21,9,21.8,11,22L11.1,21z            M22,12c0-5.2-3.9-9.4-9-10l-0.1,1c4.6,.5,8.1,4.3,8.1,9s-3.5,8.5-8.1,9l0.1,1 C18.2,21.5,22,17.2,22,12z" fill="white"></path></svg>
                            </button>
                        </div>
                        <span class="yt-logo-overlay"></span>
                        <iframe id="iframe-id" [src]="urlSafe" allow="autoplay" donotallowfullscreen></iframe>
                        <div #videocontainer id="videocontainer">
                            <button class="SLV2-yt-fullscreen-btn exitFullScreen sm" *ngIf="videoFullscreenStatus" (click)="exitFullScreen()"><img class="ml-0mr-2 bck-icn" src="selflearnv2-ui/assets/img/self-learn-v2/fullscreen-exit-icon.svg" alt=""></button>
                        </div>
                    </div>
                </div>
                <div class="SLV2-play-video-content-wrap" #vdo_mob_dscrptn_expand>
                    <div class="SLV2-play-video-title-row">
                        <h2 class="SLV2-play-video-title">{{videoFullData?.title}}</h2>
                        <button class="SLV2-mob-expand-arrow-btn" (click)="vdo_mob_dscrptn_expand.classList.toggle('expand')"><img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" /></button>
                    </div>
                    <div class="SLV2-play-subject-name physics">
                        <div class="SLV2-icn-box">
                            <img [src]="subjectIcon" />
                        </div>
                        <span>{{videoFullData?.nodes[0]?.nodeName}}</span>
                    </div>
                    <div class="SLV2-play-user-actn-row">
                        <button class="SLV2-user-btn like-btn">
                            <div class="SLV2-btn-icon" [ngClass]="{'active':this.isVideoLiked(this.videoFullData?.videoId)}" (click)="userLike()">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/like-icon.svg" />
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/like-fill-icon.svg" class="color" />
                            </div>
                            <span>{{videoLikeCount == 0 ? ' ': videoLikeCount}}</span>
                        </button>
                        <button class="SLV2-user-btn dislike-btn">
                            <div class="SLV2-btn-icon" [ngClass]="{'active': this.isVideoDisLiked(this.videoFullData?.videoId)}" (click)="userDislike()">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/dislike-icon.svg" />
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/dislike-fill-icon.svg" class="color" />
                            </div>
                            <span>Dislike</span>

                        </button>
                        <!-- <button class="SLV2-user-btn share-btn">
                            <div class="SLV2-btn-icon">
                                <img src="selflearnv2-ui/assets/img/self-learn-v2/share-icon.svg" />
                            </div>
                            <span>Share</span>
                        </button> -->
                    </div>
                    <div *ngIf="videoFullData?.description?.length>1" class="SLV2-video-description" #vdo_dscrptn_expand>
                        <div class="SLV2-descrptn-hdr">
                            <span>Description</span>
                            <button class="SLV2-descrptn-arrow-btn" (click)="vdo_dscrptn_expand.classList.toggle('collaps')"><img src="selflearnv2-ui/assets/img/self-learn-v2/down-arrow-icon.svg" /></button>
                        </div>
                        <div class="SLV2-descrptn-content">
                            <p>{{videoFullData?.description}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="SLV2-playback-col right" >
                <h3 class="SLV2-playlist-heading" *ngIf="playlists.length>0"><span>Playlist</span></h3>

                <ul class="SLV2-playlist">
                    <li *ngFor="let playlist of playlists">
                        <app-playlist-card [playlistCardData]="playlist" (videoSelected)="onVideoSelected($event)"></app-playlist-card>
                    </li>
                </ul>
            </div>
            
        </div>

    </div>
</div>